import { render, staticRenderFns } from "./embed-lib-warning.vue?vue&type=template&id=36e0441e&"
import script from "./embed-lib-warning.vue?vue&type=script&lang=js&"
export * from "./embed-lib-warning.vue?vue&type=script&lang=js&"
import style0 from "./embed-lib-warning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e0441e')) {
      api.createRecord('36e0441e', component.options)
    } else {
      api.reload('36e0441e', component.options)
    }
    module.hot.accept("./embed-lib-warning.vue?vue&type=template&id=36e0441e&", function () {
      api.rerender('36e0441e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/embed-lib-warning.vue"
export default component.exports